import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormArray, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonDropdown } from '../../../../models';
import { AuctionSurveyService } from '../../../../services/auction-survey.service';
import { LoaderService } from '../../../../services';
import constants from '../../../../utility/constants';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-auction-registeration-success',
  templateUrl: './auction-registeration-success.component.html',
  styleUrls: ['./auction-registeration-success.component.css'],
})
export class AuctionRegisterationSuccessComponent implements OnInit {
  @Input('auctionId') auctionId: number;
  @Input('auctionName') auctionTitle: string;
  @Output('goToBack') backToPage = new EventEmitter<boolean>();
  listing: Array<CommonDropdown>;
  surveyOptions: Array<any> = [];
  private subscriptions: Array<Subscription> = [];

  constructor(
    private surveyService: AuctionSurveyService,
    private router: Router,
    private route: ActivatedRoute,
    private loader: LoaderService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    this.getListing();
  }

  getListing() {
    const surveyOptions = this.surveyService.getSurveyOptionsListing().subscribe((res) => {
      this.listing = res;
    });
    this.subscriptions.push(surveyOptions)
  }

  onChange(optionId: number, isChecked: boolean) {
    (isChecked) ? this.surveyOptions.push(optionId) : this.surveyOptions.splice(this.surveyOptions.findIndex((x) => x.value == optionId), 1);
  }

  onSubmit() {
    this.loader.showLoader(true);
    let options = this.surveyOptions.join(', ');
    const savesurvey = this.surveyService
      .saveAuctionSurvey(this.auctionId, options)
      .subscribe(
        (res) => {
          this.loader.showLoader(false);
          this.toastr.success('Survey submitted successfully', constants.common.toast.successTitle, constants.common.toast.config);
          this.goToBack();
        },
        (err) => {
          this.loader.showLoader(false);
          this.toastr.error(err, constants.common.toast.errorTitle, constants.common.toast.config);
        }
      );
      this.subscriptions.push(savesurvey)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  goToBack() {
    this.backToPage.emit(true);
  }
}
